export enum TipoOcorrencia {
    PorData = 1,
    PorRecorrencia = 2,
  }